import { computed } from 'vue';
import { useStore } from "vuex";
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useMessageField = (required, messages = {}) => {
  const validator = yup.string()
    .max(400, messages['max'] || '400文字以内でご希望・ご質問内容などご入力ください')
    .requirement(required, messages['requirement'] || 'ご希望・ご質問内容は必須項目です');
  const fieldName = computed(() => 'message');

  return { validator, fieldName }
}

export const useMessageStore = () => {
  const store = useStore();
  const message = computed(() => store.state.formData.message);
  const dispatcher = computed(() => 'formData/setMessage');

  return { message, dispatcher }
}